import React, { useState, useEffect } from 'react';
import { FaBell, FaCheckCircle, FaPenFancy, FaHeart, FaStar, FaCommentDots } from 'react-icons/fa';
import { formatDistanceToNow } from 'date-fns';
import trLocale from 'date-fns/locale/tr';
import api from '../services/api';
import { useWebSocket } from '../utils/WebSocketContext';
import '../styles/Notifications.css';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const ws = useWebSocket();

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('Token mevcut değil');
        return;
      }

      const response = await api.get('/notifications', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      

      // Sort notifications by timestamp (newest first)
      const sortedNotifications = response.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      setNotifications(sortedNotifications);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  // WebSocket üzerinden gelen mesajları dinlemek
  useEffect(() => {
    if (ws) {
      ws.onmessage = (event) => {
        const newNotification = JSON.parse(event.data);
        setNotifications(prev => [newNotification, ...prev]);
      };
    }
  }, [ws]);

  const getIcon = (type) => {
    const icons = {
      like: <FaHeart className="notification-icon like" />,
      comment: <FaCommentDots className="notification-icon comment" />,
      follow: <FaCheckCircle className="notification-icon follow" />,
      read: <FaStar className="notification-icon star" />,
      'new-chapter': <FaPenFancy className="notification-icon new-chapter" />,
      default: <FaBell className="notification-icon" />,
    };
    return icons[type] || icons.default;
  };

  const markAllAsRead = async () => {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        console.error('Token mevcut değil');
        return;
      }
      
      await api.put('/notifications/mark-all-read', {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Tüm bildirimleri okundu olarak işaretle
      setNotifications(notifications.map(notification => ({ ...notification, is_read: true })));
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
    }
  };

  return (
    <div className="notifications-container">
      <div className="notifications-header">
        <h1>Bildirimler</h1>
        <button onClick={markAllAsRead} className="mark-read-button">
          Tümünü Okundu İşaretle
        </button>
      </div>
      <div className="notifications-list">
        {notifications.map(({ id, type, content, timestamp, is_read }) => (
          <div key={id} className={`notification-item ${is_read ? 'read' : 'unread'}`}>
            {getIcon(type)}
            <div className="notification-content">
              <p>{content}</p>
              <span className="notification-timestamp">
                {formatDistanceToNow(new Date(timestamp), { addSuffix: true, locale: trLocale })}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notifications;